
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class App extends Vue {
  private beats = 6;
  private ticking = false;
  private lastTouch: number = 0;
  private BPM = '0';

  private touch() {
    const now = Date.now();

    // Two taps within one second, ignoring (might be double mousedown & touchstart events)
    if (now - this.lastTouch < 1000) {
      return;
    }

    this.ticking = !this.ticking;

    if (!this.ticking) {
      // End touch, calculate BPM
      this.BPM = '' + Math.floor(this.beats * 60 * 1000 / (now - this.lastTouch));
    } else {
      this.BPM = '...';
    }

    this.lastTouch = now;
  }
}
